module.exports = __webpack_public_path__ + "img/trading1.8ffbaa8c.svg";